import { Graph, Node } from '@antv/x6'
import { ImageNodeState } from "../services/modal"

export const ImageNode = ({node, graph}: {node: Node, graph: Graph}) => {
  const data: ImageNodeState = node.getData()
  let { url } = data
  if (!url) {
    url = '/images/default.jpg'
  }
  return <img src={url} alt="" style={{height: '100%', width: '100%'}} />;
}

